import { render, staticRenderFns } from "./ShareLinks.vue?vue&type=template&id=40ce9774&scoped=true&"
import script from "./ShareLinks.vue?vue&type=script&lang=js&"
export * from "./ShareLinks.vue?vue&type=script&lang=js&"
import style0 from "./ShareLinks.vue?vue&type=style&index=0&id=40ce9774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ce9774",
  null
  
)

export default component.exports